import * as Sentry from "@sentry/react";

export const sentryEnabled =
  process.env.REACT_APP_FEATURE_SENTRY_ENABLED === "true" &&
  Boolean(process.env.REACT_APP_SENTRY_DSN);

let initialized = false;

export const initFrontendMonitoring = () => {
  if (!sentryEnabled || initialized) return;

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_DSN,
    environment: process.env.REACT_APP_ENVIRONMENT || process.env.NODE_ENV,
    tracesSampleRate: Number(process.env.REACT_APP_SENTRY_TRACES_SAMPLE_RATE || 0.1),
    sendDefaultPii: false,
    beforeSend(event) {
      if (event.request?.headers) {
        delete event.request.headers.Authorization;
      }
      return event;
    },
  });

  initialized = true;
};

export const captureFrontendException = (error, context = {}) => {
  if (sentryEnabled) {
    Sentry.captureException(error, { extra: context });
  } else {
    console.error(error, context);
  }
};

export { Sentry };
